export const LOAD_PROFILE_REQUEST = 'LOAD_PROFILE_REQUEST'
export const LOAD_PROFILE_SUCCESS = 'LOAD_PROFILE_SUCCESS'
export const LOAD_PROFILE_ERROR = 'LOAD_PROFILE_ERROR'

export const UPDATE_PROFILE_REQUEST = "UPDATE_PROFILE_REQUEST";
export const UPDATE_PROFILE_SUCCESS = "UPDATE_PROFILE_SUCCESS";
export const UPDATE_PROFILE_ERROR = "UPDATE_PROFILE_ERROR";

export const loadProfile = () => {
    return {
        type: 'CALL_API',
        types: [LOAD_PROFILE_REQUEST, LOAD_PROFILE_SUCCESS, LOAD_PROFILE_ERROR],
        path: 'api/users',
    };
}

export const updateProfile = (profile) => {
    return {
        type: 'CALL_API',
        types: [UPDATE_PROFILE_REQUEST, UPDATE_PROFILE_SUCCESS, UPDATE_PROFILE_ERROR],
        path: 'api/users',
        method: 'post',
        payload: profile,
        redirect: '/',
        message: 'Your profile has been updated',
    };
}


// WEBPACK FOOTER //
// ./src/actions/profile.js